var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "burger-menu", class: { active: _vm.$root.menu_active } },
    [
      _c("div", { staticClass: "burger-flex" }, [
        _c(
          "main",
          {
            staticClass: "burger-main",
            style: "min-height:" + _vm.minHeight + ";",
          },
          [
            _c("div", [
              _c(
                "ul",
                {
                  staticClass: "first-level items sub-menu-items",
                  class: _vm.activePage !== 1 ? "hidden" : "",
                },
                [
                  _vm._l(_vm.navigation, function (item) {
                    return _c(
                      "li",
                      {
                        key: item.ID,
                        class: [
                          "menu-item",
                          "menu-item-type-custom",
                          "menu-item-object-custom",
                          "item",
                          "menu-item-" + item.ID,
                        ],
                      },
                      [
                        Object.keys(item.children).length > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "a",
                                on: {
                                  click: function ($event) {
                                    return _vm.switchPage(item.ID, 2)
                                  },
                                },
                              },
                              [
                                _c("span", [
                                  _c("span", {
                                    staticClass: "title",
                                    domProps: { innerHTML: _vm._s(item.title) },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                        fill: "#CA1744",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                        fill: "#CA1744",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            )
                          : _c(
                              "a",
                              {
                                class: item.is_current ? "current" : "",
                                attrs: { href: item.url },
                              },
                              [
                                _c("span", [
                                  _c("span", {
                                    staticClass: "title",
                                    domProps: { innerHTML: _vm._s(item.title) },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "16",
                                      height: "16",
                                      viewBox: "0 0 16 16",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                        fill: "#CA1744",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("path", {
                                      attrs: {
                                        d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                        fill: "#CA1744",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("BurgerFooter", {
                    attrs: {
                      "secondary-menu": _vm.secondaryMenu,
                      "social-media": _vm.socialMedia,
                      "available-langs": _vm.availableLangs,
                      "active-page": _vm.activePage,
                    },
                    on: { toggleLang: _vm.toggleLangSwitcher },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "second-level sub-menu-items",
                  class: [
                    _vm.prevActivePage === "lang" && _vm.activePage === 1
                      ? "hidden-right no-trans"
                      : "",
                    _vm.activePage === 1 ? "hidden-right" : "",
                    _vm.prevActivePage === 1 && _vm.activePage === "lang"
                      ? "hidden-left no-trans"
                      : "",
                    _vm.prevActivePage === 2 && _vm.activePage === "lang"
                      ? "hidden-left"
                      : "",
                    _vm.someChildHasChildren(_vm.activeSubmenu.children)
                      ? "two-levels"
                      : "",
                  ],
                },
                [
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "back-btn",
                        on: {
                          click: function ($event) {
                            return _vm.switchPage(null, 1)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 15 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M0.549998 8.80607L2.96875 11.2498C3.02685 11.3084 3.09598 11.3549 3.17214 11.3866C3.2483 11.4184 3.32999 11.4347 3.4125 11.4347C3.49501 11.4347 3.5767 11.4184 3.65286 11.3866C3.72902 11.3549 3.79815 11.3084 3.85625 11.2498C3.91483 11.1917 3.96132 11.1226 3.99306 11.0464C4.02479 10.9703 4.04112 10.8886 4.04112 10.8061C4.04112 10.7236 4.02479 10.6419 3.99306 10.5657C3.96132 10.4895 3.91483 10.4204 3.85625 10.3623L1.63125 8.12482H14.375C14.5408 8.12482 14.6997 8.05897 14.8169 7.94176C14.9342 7.82455 15 7.66558 15 7.49982C15 7.33405 14.9342 7.17508 14.8169 7.05787C14.6997 6.94066 14.5408 6.87482 14.375 6.87482H1.59375L3.85625 4.61232C3.96705 4.49608 4.02887 4.34165 4.02887 4.18107C4.02887 4.02048 3.96705 3.86605 3.85625 3.74982C3.79815 3.69124 3.72902 3.64474 3.65286 3.61301C3.5767 3.58128 3.49501 3.56494 3.4125 3.56494C3.32999 3.56494 3.2483 3.58128 3.17214 3.61301C3.09598 3.64474 3.02685 3.69124 2.96875 3.74982L0.549998 6.15607C0.198872 6.50763 0.00164795 6.98419 0.00164795 7.48107C0.00164795 7.97794 0.198872 8.4545 0.549998 8.80607Z",
                                fill: "black",
                              },
                            }),
                          ]
                        ),
                        _vm._v("\n              Back\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.activeSubmenu.children, function (item) {
                    return _c(
                      "li",
                      {
                        key: item.ID,
                        class: [
                          "menu-item",
                          "sub-menu-item",
                          "menu-item-type-custom",
                          "menu-item-object-custom",
                          "menu-item-" + item.ID,
                        ],
                      },
                      [
                        _vm.someChildHasChildren(_vm.activeSubmenu.children)
                          ? _c("div", [
                              _c("div", { staticClass: "top" }, [
                                _c("span", {
                                  staticClass: "title",
                                  domProps: { innerHTML: _vm._s(item.title) },
                                }),
                                _vm._v(" "),
                                item.subtitle
                                  ? _c("p", {
                                      staticClass: "small subtitle",
                                      domProps: {
                                        innerHTML: _vm._s(item.subtitle),
                                      },
                                    })
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "items" },
                                _vm._l(item.children, function (subchild) {
                                  return _c("div", { key: subchild.ID }, [
                                    subchild.trigger_lead_popup
                                      ? _c(
                                          "button",
                                          {
                                            staticClass: "a",
                                            class: subchild.is_current
                                              ? "current"
                                              : "",
                                            on: {
                                              click: _vm.$root.toggle_popup,
                                            },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  subchild.title
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "16",
                                                  height: "16",
                                                  viewBox: "0 0 16 16",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                                    fill: "#CA1744",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                                    fill: "#CA1744",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "a",
                                          {
                                            class: subchild.is_current
                                              ? "current"
                                              : "",
                                            attrs: { href: subchild.url },
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  subchild.title
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "svg",
                                              {
                                                attrs: {
                                                  width: "16",
                                                  height: "16",
                                                  viewBox: "0 0 16 16",
                                                  fill: "none",
                                                  xmlns:
                                                    "http://www.w3.org/2000/svg",
                                                },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                                    fill: "#CA1744",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("path", {
                                                  attrs: {
                                                    d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                                    fill: "#CA1744",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ])
                                }),
                                0
                              ),
                            ])
                          : _c("div", { staticClass: "item" }, [
                              item.trigger_lead_popup
                                ? _c(
                                    "button",
                                    {
                                      staticClass: "a",
                                      class: item.is_current ? "current" : "",
                                      on: { click: _vm.$root.toggle_popup },
                                    },
                                    [
                                      _c("span", [
                                        _c("span", {
                                          staticClass: "title",
                                          domProps: {
                                            innerHTML: _vm._s(item.title),
                                          },
                                        }),
                                        _vm._v(" "),
                                        item.subtitle
                                          ? _c("p", {
                                              staticClass: "small subtitle",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.subtitle
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                              fill: "#CA1744",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                              fill: "#CA1744",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  )
                                : _c(
                                    "a",
                                    {
                                      class: item.is_current ? "current" : "",
                                      attrs: { href: item.url },
                                    },
                                    [
                                      _c("span", [
                                        _c("span", {
                                          staticClass: "title",
                                          domProps: {
                                            innerHTML: _vm._s(item.title),
                                          },
                                        }),
                                        _vm._v(" "),
                                        item.subtitle
                                          ? _c("p", {
                                              staticClass: "small subtitle",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.subtitle
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M4.06667 3.33313C3.93482 3.33368 3.80609 3.37332 3.69677 3.44703C3.58745 3.52074 3.50244 3.62521 3.45249 3.74723C3.40254 3.86925 3.38989 4.00334 3.41615 4.13255C3.4424 4.26176 3.50638 4.38028 3.6 4.47313L7.12667 7.9998L3.6 11.5265C3.53751 11.5884 3.48792 11.6622 3.45407 11.7434C3.42023 11.8247 3.4028 11.9118 3.4028 11.9998C3.4028 12.0878 3.42023 12.1749 3.45407 12.2562C3.48792 12.3374 3.53751 12.4112 3.6 12.4731C3.72491 12.5973 3.89388 12.667 4.07 12.667C4.24612 12.667 4.41509 12.5973 4.54 12.4731L8.54 8.47313C8.60249 8.41116 8.65208 8.33742 8.68593 8.25618C8.71977 8.17494 8.7372 8.0878 8.7372 7.9998C8.7372 7.91179 8.71977 7.82465 8.68593 7.74341C8.65208 7.66217 8.60249 7.58844 8.54 7.52646L4.54 3.52646C4.47771 3.46468 4.40383 3.41579 4.3226 3.38262C4.24138 3.34944 4.1544 3.33262 4.06667 3.33313Z",
                                              fill: "#CA1744",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c("path", {
                                            attrs: {
                                              d: "M8.19167 3.33313C8.05982 3.33368 7.9311 3.37332 7.82178 3.44703C7.71246 3.52074 7.62744 3.62521 7.57749 3.74723C7.52754 3.86925 7.5149 4.00334 7.54115 4.13255C7.56741 4.26176 7.63139 4.38028 7.72501 4.47313L11.2517 7.9998L7.72501 11.5265C7.66252 11.5884 7.61292 11.6622 7.57908 11.7434C7.54523 11.8247 7.52781 11.9118 7.52781 11.9998C7.52781 12.0878 7.54523 12.1749 7.57908 12.2562C7.61292 12.3374 7.66252 12.4112 7.72501 12.4731C7.84991 12.5973 8.01888 12.667 8.19501 12.667C8.37113 12.667 8.5401 12.5973 8.66501 12.4731L12.665 8.47313C12.7275 8.41116 12.7771 8.33742 12.8109 8.25618C12.8448 8.17494 12.8622 8.0878 12.8622 7.9998C12.8622 7.91179 12.8448 7.82465 12.8109 7.74341C12.7771 7.66217 12.7275 7.58844 12.665 7.52646L8.66501 3.52646C8.60271 3.46468 8.52884 3.41579 8.44761 3.38262C8.36639 3.34944 8.27941 3.33262 8.19167 3.33313Z",
                                              fill: "#CA1744",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                            ]),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("BurgerFooter", {
                    attrs: {
                      "secondary-menu": _vm.secondaryMenu,
                      "social-media": _vm.socialMedia,
                      "available-langs": _vm.availableLangs,
                      "active-page": _vm.activePage,
                    },
                    on: { toggleLang: _vm.toggleLangSwitcher },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "lang-level sub-menu-items",
                  class:
                    _vm.activePage === 1 || _vm.activePage === 2
                      ? "hidden-right"
                      : "",
                },
                [
                  _c("li", [
                    _c(
                      "button",
                      {
                        staticClass: "back-btn",
                        on: {
                          click: function ($event) {
                            return _vm.switchPage(null, _vm.prevActivePage)
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "15",
                              viewBox: "0 0 15 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M0.549998 8.80607L2.96875 11.2498C3.02685 11.3084 3.09598 11.3549 3.17214 11.3866C3.2483 11.4184 3.32999 11.4347 3.4125 11.4347C3.49501 11.4347 3.5767 11.4184 3.65286 11.3866C3.72902 11.3549 3.79815 11.3084 3.85625 11.2498C3.91483 11.1917 3.96132 11.1226 3.99306 11.0464C4.02479 10.9703 4.04112 10.8886 4.04112 10.8061C4.04112 10.7236 4.02479 10.6419 3.99306 10.5657C3.96132 10.4895 3.91483 10.4204 3.85625 10.3623L1.63125 8.12482H14.375C14.5408 8.12482 14.6997 8.05897 14.8169 7.94176C14.9342 7.82455 15 7.66558 15 7.49982C15 7.33405 14.9342 7.17508 14.8169 7.05787C14.6997 6.94066 14.5408 6.87482 14.375 6.87482H1.59375L3.85625 4.61232C3.96705 4.49608 4.02887 4.34165 4.02887 4.18107C4.02887 4.02048 3.96705 3.86605 3.85625 3.74982C3.79815 3.69124 3.72902 3.64474 3.65286 3.61301C3.5767 3.58128 3.49501 3.56494 3.4125 3.56494C3.32999 3.56494 3.2483 3.58128 3.17214 3.61301C3.09598 3.64474 3.02685 3.69124 2.96875 3.74982L0.549998 6.15607C0.198872 6.50763 0.00164795 6.98419 0.00164795 7.48107C0.00164795 7.97794 0.198872 8.4545 0.549998 8.80607Z",
                                fill: "black",
                              },
                            }),
                          ]
                        ),
                        _vm._v("\n              Back\n            "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.availableLangs, function (lang) {
                    return _c("li", { key: "burger-" + lang.id }, [
                      _c(
                        "a",
                        {
                          class: [
                            "lang-button",
                            lang.current_lang ? "is-current" : "",
                          ],
                          attrs: { href: lang.url },
                        },
                        [
                          _c("div", { staticClass: "lang-button-inner" }, [
                            _c(
                              "span",
                              { staticClass: "lang-switcher-flag-wrapper" },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "https://flagcdn.com/h40/" +
                                      lang.flag_code +
                                      ".png",
                                    srcset:
                                      "https://flagcdn.com/h80/" +
                                      lang.flag_code +
                                      ".png 2x,https://flagcdn.com/h120/" +
                                      lang.flag_code +
                                      ".png 3x",
                                    height: "20",
                                    alt: "" + lang.name + " flag",
                                  },
                                }),
                              ]
                            ),
                            _vm._v(
                              "\n                " +
                                _vm._s(lang.name) +
                                "\n              "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "14",
                                height: "11",
                                viewBox: "0 0 14 11",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M13.0194 1.08475L4.95828 9.14525C4.90408 9.19967 4.83968 9.24284 4.76875 9.2723C4.69783 9.30176 4.62179 9.31692 4.54499 9.31692C4.46819 9.31692 4.39215 9.30176 4.32123 9.2723C4.2503 9.24284 4.1859 9.19967 4.1317 9.14525L1.01437 6.025C0.960168 5.97059 0.89576 5.92742 0.824837 5.89796C0.753914 5.8685 0.677872 5.85334 0.601074 5.85334C0.524276 5.85334 0.448233 5.8685 0.37731 5.89796C0.306387 5.92742 0.241979 5.97059 0.187782 6.025C0.133371 6.0792 0.0901966 6.14361 0.0607373 6.21453C0.031278 6.28546 0.0161133 6.3615 0.0161133 6.4383C0.0161133 6.51509 0.031278 6.59114 0.0607373 6.66206C0.0901966 6.73298 0.133371 6.79739 0.187782 6.85159L3.30628 9.9695C3.63525 10.2979 4.08106 10.4823 4.54587 10.4823C5.01067 10.4823 5.45648 10.2979 5.78545 9.9695L13.8459 1.91075C13.9003 1.85657 13.9434 1.7922 13.9728 1.72133C14.0022 1.65046 14.0173 1.57448 14.0173 1.49775C14.0173 1.42103 14.0022 1.34505 13.9728 1.27418C13.9434 1.20331 13.9003 1.13894 13.8459 1.08475C13.7918 1.03034 13.7273 0.987169 13.6564 0.95771C13.5855 0.928251 13.5095 0.913086 13.4327 0.913086C13.3559 0.913086 13.2798 0.928251 13.2089 0.95771C13.138 0.987169 13.0736 1.03034 13.0194 1.08475Z",
                                  fill: "currentColor",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("BurgerFooter", {
                    attrs: {
                      "secondary-menu": _vm.secondaryMenu,
                      "social-media": _vm.socialMedia,
                      "available-langs": _vm.availableLangs,
                      "active-page": _vm.activePage,
                    },
                    on: { toggleLang: _vm.toggleLangSwitcher },
                  }),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }